import { authApiInstance, tokenStore } from './client.js';

export const authApi = {
  login: async ({ email, password }) => {
    const res = await authApiInstance.post('/auth/login', { email, password }).then(r => r.data);
    const { token, user } = res.data ?? res;
    if (token) tokenStore.set(token);
    return { token, user };
  },

  register: async (payload) => {
    const res = await authApiInstance.post('/auth/register', payload).then(r => r.data);
    const { token, user } = res.data ?? res;
    if (token) tokenStore.set(token);
    return { token, user };
  },

  profile: async () => {
    const res = await authApiInstance.get('/auth/profile').then(r => r.data);
    const user = res.data ?? res;
    return { user };
  },

  logout: async () => {
    try { await authApiInstance.post('/auth/logout', {}).then(r => r.data); } catch (_) {}
    tokenStore.remove();
  },

  changePassword: (payload) => authApiInstance.put('/auth/password', payload).then(r => r.data),
};
